import EmailReminderChangeType from 'owa-service/lib/contract/EmailReminderChangeType';
import { mutator } from 'satcheljs';
import {
    appendToInboxRemindersStoreUpdate,
    removeInboxReminderStoreUpdate,
    replaceMatchingReminderStoreUpdate,
} from '../actions/inboxRemindersActions';

mutator(appendToInboxRemindersStoreUpdate, actionMessage => {
    const { inboxReminderToAppend, event } = actionMessage;
    if (event.InboxReminders) {
        event.InboxReminders.push(inboxReminderToAppend);
    } else {
        event.InboxReminders = [inboxReminderToAppend];
    }
});

mutator(removeInboxReminderStoreUpdate, actionMessage => {
    let { idToRemove, event } = actionMessage;

    const IsOccurrenceOrException =
        event.CalendarItemType === 'Occurrence' || event.CalendarItemType === 'Exception';
    const reminderToRemove = event.InboxReminders.filter(reminder => reminder.Id === idToRemove)[0];

    // When deleting a series reminder on an exception, we need to keep the reminder in the list but
    // mark it as deleted. If we just remove it, we would later mistake it for a new series reminder.
    if (
        IsOccurrenceOrException &&
        reminderToRemove.OccurrenceChange !== EmailReminderChangeType.Added
    ) {
        reminderToRemove.OccurrenceChange = EmailReminderChangeType.Deleted;
    } else {
        event.InboxReminders.remove(reminderToRemove);
    }
});

mutator(replaceMatchingReminderStoreUpdate, actionMessage => {
    const { reminder, event } = actionMessage;
    for (let i = 0; i < event.InboxReminders.length; i++) {
        if (event.InboxReminders[i].Id === reminder.Id) {
            event.InboxReminders[i] = reminder;
            break;
        }
    }
});
